import { render, staticRenderFns } from "./PartnerUser.vue?vue&type=template&id=3442da60&"
import script from "./PartnerUser.vue?vue&type=script&lang=ts&"
export * from "./PartnerUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports